import axios from 'axios';

const { VUE_APP_BASE_URL } = process.env;

export const fetchAllPrice = async (projectId, params) => axios({
  url: `/projects/${projectId}/sku/prices?[project]=${projectId}`,
  baseURL: `${VUE_APP_BASE_URL}/api/ocean/v2/`,
  params
});

export const priceExport = async (projectId, data) => axios({
  url: `/projects/${projectId}/sku/prices/export`,
  baseURL: `${VUE_APP_BASE_URL}/api/ocean/v2/`,
  method: 'POST',
  data
});

export default {
  fetchAllPrice,
  priceExport
};
